import { createStore, applyMiddleware, combineReducers, Action } from 'redux'
import createSagaMiddleware from 'redux-saga'
import logger from 'redux-logger'
import { connectRouter, routerMiddleware } from 'connected-react-router'
import { reducers, sagas } from './reducers'
import history from '../history'
import { all, call } from 'redux-saga/effects'

const _routerMiddleware = routerMiddleware(history)
const sagaMiddleware = createSagaMiddleware()

const middlewares = [sagaMiddleware, _routerMiddleware]

if (process.env.DEPLOY_ENV !== 'live' && process.env.NODE_ENV !== 'test') {
  middlewares.push(logger)
}

const appReducer = combineReducers({
  ...reducers,
  router: connectRouter(history),
})

const rootReducer = (state: any, action: Action) => {
  if (action.type === 'RESET_STORE') {
    state = undefined
  }

  return appReducer(state, action)
}

const configureSaga = (sagas) => {
  const staticSagas = sagas

  // 首次启动sagaMiddleware
  sagaMiddleware.run(function* () {
    yield all([...staticSagas].map(call))
  })

  return {
    add: (saga) => {
      sagaMiddleware.run(function* () {
        yield all((saga || []).map(call))
      })
    },
  }
}

const store = createStore(rootReducer, applyMiddleware(...middlewares))
export const sagaManager = configureSaga(sagas)

export default store
